import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MembershipService } from 'services';
import { MembershipPricingTier, MembershipType } from 'models';

@Component({
    selector: 'app-promocode-lookup',
    template: require('./promocode-lookup.component.html'),
    styles: [require('./promocode-lookup.component.scss')],
})

export class PromoCodeLookupComponent implements OnInit {

    constructor(private membershipService: MembershipService) { }

    ngOnInit() {

        if (!this.membershipType) {
            throw new Error(
                `You must define membership type`
            );
        }
    }

    @Input()
    membershipType: MembershipType;
   
    @Output() onLookupSuccess: EventEmitter<MembershipPricingTier[]> = new EventEmitter();

    promoCode: string = "";
    error: string;
    success: boolean;

    lookupVoucher(form: NgForm) {
        if (form.valid) {
            this.error = null;
            this.success = false;
            this.membershipService.getPricingTierFromPromoCode(this.promoCode, this.membershipType).subscribe(r => {
                if (typeof r === 'string') {
                    this.error = r;
                } else {
                    this.onLookupSuccess.emit(r);
                    this.success = true;
                }

                this.promoCode = "";
            });
        }
    }
}
